import {
  DETAILS_PAGE_URL,
  REGISTRY_URL,
  LIST_PAGE_URL,
  CARBON_INTENSITY_INDICATOR_URL,
  HOME_PAGE_URL,
  NOT_FOUND_PAGE_URL,
  USER_MANAGEMENT_URL,
  CALENDAR_URL
} from './routes';

export const isTabEnabled = (
  currentTab: NAVIGATION_TABS,
  disabledTabs: NAVIGATION_TABS[]
) => {
  return disabledTabs.find((tab) => tab === currentTab) === undefined;
};

export const TABS_LIST = (
  disabledTabs: NAVIGATION_TABS[]
): NAVIGATION_TABS[] => {
  const tabs: NAVIGATION_TABS[] = [];

  let navTab: keyof typeof NAVIGATION_TABS;
  for (navTab in NAVIGATION_TABS) {
    const value = NAVIGATION_TABS[navTab];
    if (isTabEnabled(value, disabledTabs)) {
      tabs.push(value);
    }
  }

  return tabs;
};

/**
 * Order of the values in this enum
 * determine the order of the navigation
 * tabs.
 */
export enum NAVIGATION_TABS {
  CALENDAR = 'Calendar',
  VESSELS = 'Vessels',
  REGISTRY = 'Registry',
  POSITION_REPORT = 'Position Report',
  CII = 'CII',
  USER_MANAGEMENT = 'User Management',
  /**
   * Root page (Map in this case) needs
   * to be last in list or active index
   * won't work properly
   */
  MAP = 'Map'
}

export const tabLinks = (tab: string) => {
  switch (tab) {
    case NAVIGATION_TABS.CALENDAR:
      return CALENDAR_URL;
    case NAVIGATION_TABS.VESSELS:
      return DETAILS_PAGE_URL;
    case NAVIGATION_TABS.REGISTRY:
      return REGISTRY_URL;
    case NAVIGATION_TABS.POSITION_REPORT:
      return LIST_PAGE_URL;
    case NAVIGATION_TABS.CII:
      return CARBON_INTENSITY_INDICATOR_URL;
    case NAVIGATION_TABS.USER_MANAGEMENT:
      return USER_MANAGEMENT_URL;
    case NAVIGATION_TABS.MAP:
      return HOME_PAGE_URL;
    default:
      return NOT_FOUND_PAGE_URL;
  }
};
